<template>
  <div class="activity-view">
    <ActivityList :actions-to-hide-details-button="['published', 'listed', 'unpublished', 'create.bidder',
                   'update.bidder', 'update.increment_table', 'reserved','cancelled.settlements','paid.invoice','mark_collected','unmark_collected','cancelled.invoice', 'unpaid.invoice']"
                  :for="'auction'"
                  :actions="actions"
                  :value-visualizer="valueVisualizer">

      <template v-slot:text="{activity}">
        {{ actions[activity.action] ? actions[activity.action].message : activity.action }}
      </template>

      <template slot="modal-body(update.premiums)" slot-scope="{activity}">
        <activity-premiums-table :activity="activity"/>
      </template>

      <template slot="modal-body(create.premiums)" slot-scope="{activity}">
        <activity-premiums-table :activity="activity"/>
      </template>

      <template slot="modal-body(create.auction_increment)" slot-scope="{activity}">
        <activity-increments-table :activity="activity"/>
      </template>

      <template slot="modal-body(update.auction_increment)" slot-scope="{activity}">
        <activity-increments-table :activity="activity"/>
      </template>
      <template slot="modal-body(update.invoice_miscellaneous_items)" slot-scope="{activity}">
        <activity-miscellaneous-table :activity="activity"/>
      </template>
    </ActivityList>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import ActivityList from "../../../activities/ActivityList";
  import ActivityIncrementsTable from "./ActivityIncrementsTable";
  import ActivityPremiumsTable from "./ActivityPremiumsTable";
  import salesActivityHelper from "@/modules/sales/view/activities/salesActivityHelper";
  import ActivityMiscellaneousTable from "@/modules/receipt/view/activities/ActivityMiscellaneousTable";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: activityMapActions} = createNamespacedHelpers('activities');
  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateDepartment} = createNamespacedHelpers('setup/department');

  export default {
    name: "ActivitiesView",
    components: {ActivityPremiumsTable, ActivityIncrementsTable, ActivityList, ActivityMiscellaneousTable},
    data: () => {
      return {
        actions: salesActivityHelper.actions
      };
    },
    computed: {
      ...mapState({
        sale: state => state.view.currentSale,
        ...mapStateBranch(['branches']),
        ...mapStateDepartment(['departments']),
      }),
    },
    methods: {
      ...activityMapActions(['setActivitiesParams']),
      valueVisualizer: salesActivityHelper.valueVisualizer
    },
    beforeMount() {
      this.setActivitiesParams({object: this.sale, source: 'auction'})
    }
  }
</script>

<style lang="scss">

</style>
